module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/operator-info.c1ef1241.svg";